import React from "react";

const PackageFlags = props => {
  const flags = props.promotions || [];

  return flags.length
    ? (
      <ul data-component="label-list" className={props.isBookOnline ? "online" : null}>
        {flags.map((flag) => {
          const text = flag['name'];
          const type = flag['slug'];
          return <li key={`flag-${type}`} data-type={type}>{text}</li>
        })}
      </ul>
    )
    : null;
};

export default PackageFlags;



// WEBPACK FOOTER //
// ./components/search/package/PackageFlags.jsx